import { Fragment, useContext, useState, useRef, useEffect } from "react";
import AuthContext from "../../../../auth/AuthContext";
import AlertService from "../../../../services/AlertService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CSVLink } from "react-csv";
import QuizMCQService from "../../../../services/QuizMCQService";
import { Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import { FiUpload } from "react-icons/fi";

const UploadQuizMCQ = () => {
    const navigate = useNavigate();
    const { quizName } = useParams();
    const { state } = useLocation();
    const storedId = sessionStorage.getItem("quizId");
    const id = state?.id  || storedId;
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState("");
    const [buttonText, setButtonText] = useState("Upload");
    const [results, setResults] = useState([]);
    const fileInputRef = useRef();
    const submitControllerRef = useRef(null);

    const headers = [
        { label: "Question", key: "question" },
        { label: "Option1", key: "option1" },
        { label: "Option1Answer", key: "option1Answer" },
        { label: "Option2", key: "option2" },
        { label: "Option2Answer", key: "option2Answer" },
        { label: "Option3", key: "option3" },
        { label: "Option3Answer", key: "option3Answer" },
        { label: "Option4", key: "option4" },
        { label: "Option4Answer", key: "option4Answer" },
        { label: "Option5", key: "option5" },
        { label: "Option5Answer", key: "option5Answer" },
        { label: "HasGraceMark", key: "hasGraceMark" },
        { label: "Status", key: "status" },
        { label: "Reason", key: "reason" },
    ];

    const authContext = useContext(AuthContext);



const onSubmitHandler = async (event) => {
  event.preventDefault();

  if (!file) {
    setFileError("Please select a file before uploading.");
    return;
  }

  setFileError("");

  if (submitControllerRef.current) {
    submitControllerRef.current.abort();
  }
  const controller = new AbortController();
  submitControllerRef.current = controller;

  setLoading(true);
  setButtonText("Processing");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("filename", file.name);

  try {
    const data = await QuizMCQService.ImportMCQ(
      id,
      formData,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (data.isSuccess) {
      setResults(data.data);
      AlertService.success("Quiz MCQ Questions are imported successfully!");
    } else {
      AlertService.error(data.errorMessage);
    }
  } catch (error) {
    if (error.name === "AbortError") return;
    AlertService.error("Error occurred during upload.");
  } finally {
    if (!controller.signal.aborted) {
      setButtonText("Upload");
      setLoading(false);
    }
  }
};

// Unmount cleanup
useEffect(() => {
  return () => {
    submitControllerRef.current?.abort();
  };
}, []);

    const handleChange = (event) => {
        if (event.target.files.length > 0) {
            setFile(event.target.files[0]);
            setFileError("");
        } else {
            setFile(null);
        }
    };

    return (
        <Fragment>
            <div className="container-fluid mt-3 pt-3">
                <Form onSubmit={onSubmitHandler} noValidate>
                    <Form.Group as={Row} className="mb-3 align-items-center">
                        <Form.Label column md={2} className="d-flex align-items-center" style={{ minHeight: "48px" }}>
                            Select Excel File
                        </Form.Label>
                        <Col md={10}>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder={file ? file.name : "Upload file"}
                                    readOnly
                                    className="py-3 custom-input custom-input-color"
                                    style={{ background: "#fff" }}
                                    isInvalid={!!fileError}
                                />
                                <Button
                                    variant="primary"
                                    className="px-3 rounded rounded-start-0"
                                    onClick={() => fileInputRef.current.click()}
                                    disabled={loading}
                                    type="button"
                                >
                                    <FiUpload className="fs-4" />
                                </Button>
                                <Form.Control
                                    type="file"
                                    ref={fileInputRef}
                                    onChange={handleChange}
                                    className="d-none"
                                    accept=".xls,.xlsx,.csv"
                                />
                            </InputGroup>
                            {fileError && (
                                <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                                    {fileError}
                                </Form.Control.Feedback>
                            )}
                        </Col>
                    </Form.Group>
                    <Row className="mb-3">
                        <Col className="d-flex justify-content-end align-items-center">
                            <button

                                className="me-3 px-4 py-2 px-md-5 btn btn-outline"
                                onClick={() => navigate(`/masters-quizzes/${quizName}/mcq`, { state: { id: id } })}
                                disabled={loading}
                                type="button"
                            >
                                Cancel
                            </button>
                            {results.length === 0 && (
                            <Button
                                variant="primary"
                                className="px-4 px-md-5 py-2"
                                disabled={loading}
                                type="submit"
                            >
                                {buttonText}
                            </Button>
                            )}
                            {!loading && results.length > 0 && (
                                <CSVLink
                                    data={results}
                                    filename={"Quiz-MCQ-Upload-Results.csv"}
                                    className="btn btn-success ms-3 px-4 py-2"
                                    headers={headers}
                                >
                                    Download Results
                                </CSVLink>
                            )}
                        </Col>
                    </Row>
                </Form>
            </div>
        </Fragment>
    );
};

export default UploadQuizMCQ;
